import axios from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getProspectPreference,
  updateProspectPreference,
} from 'services/prospectPreferenceService';
import useFortressQuery from 'hooks/queries/useFortressQuery';

export const useFetchProspectPreference = ({
  organizationId,
  propertyId,
  prospectId,
}) => {
  return useFortressQuery({
    queryKey: ['prospectPreferences', prospectId],
    queryFn: ({ signal }) =>
      getProspectPreference({
        organizationId,
        propertyId,
        prospectId,
        options: { signal },
      }),
    staleTime: 60000,
    enabled: Boolean(organizationId && propertyId && prospectId),
  });
};

export const useUpdateProspectPreference = ({
  organizationId,
  propertyId,
  prospectId,
  portalUserId,
}) => {
  const queryClient = useQueryClient();
  const source = axios.CancelToken.source();
  const { token } = source;
  const options = { cancelToken: token };
  return useMutation({
    mutationFn: (partialProspectPreference) =>
      updateProspectPreference({
        organizationId,
        propertyId,
        prospectId,
        partialProspectPreference,
        options,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['portalUserUnits', portalUserId],
      });
      return queryClient.invalidateQueries({
        queryKey: ['prospectPreferences', prospectId],
      });
    },
    onError: (error) => {
      return error;
    },
  });
};
